module.exports = __webpack_public_path__ + "img/features_icon_1.72e682a3.svg";